<i18n>
{
  "cl": { "walletBalance": "Saldo a favor:" },
  "pe": { "walletBalance": "Saldo a favor:" },
  "br": { "walletBalance": "Saldo a favor:" }
}
</i18n>
<template>
  <div v-if="clientBalance && $i18n.locale==='cl'" class="wallet-card">
    <b-tag icon="fa-solid fa-wallet" type="is-primary" size="is-medium" :rounded="true">
      <span class="main-text has-text-secondary">
        <span>{{ $t('walletBalance') }}</span>
        <b>{{ `$ ${formatNumber(clientBalance)}` }}</b>
      </span>
    </b-tag>
  </div>
</template>

<script>
import { formatNumber } from '@/infrastructure/format';

export default {
  name: 'WalletBalance',
  props: {
    clientBalance: { type: Number, default: 0 }
  },
  data() {
    return {};
  },
  methods: {
    formatNumber: number => formatNumber({ number })
  }
};
</script>

<style scoped>
.wallet-card {
  text-align: right;
  font-size: 2rem;
  align-self: flex-end;
  margin: 0rem 0rem 1rem 0rem;
}
.main-text {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
}
</style>
